import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../store/slices/authSlice';
import { persistor } from '../store/store';

export const useAuth = () => {
  const dispatch = useDispatch();
  const { user, otp, isAuthenticated } = useSelector((state) => state.auth);

  const handleLogout = async () => {
    // First dispatch the logout action to clear Redux state
    dispatch(logout());
    
    // Then clear the persisted data
    try {
      await persistor.purge();
      console.log('Persisted data cleared successfully');
    } catch (error) {
      console.error('Error clearing persisted data:', error);
    }
  };

  return {
    user,
    otp,
    isAuthenticated,
    logout: handleLogout,
  };
};
